import createIcon from '../../createIcon';

/**
 * @component @name GroupRemove
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjQgOVYxMUgxOFY5SDI0Wk04IDRDNS43OSA0IDQgNS43OSA0IDhDNCAxMC4yMSA1Ljc5IDEyIDggMTJDMTAuMjEgMTIgMTIgMTAuMjEgMTIgOEMxMiA1Ljc5IDEwLjIxIDQgOCA0Wk04IDEzQzUuMzMgMTMgMCAxNC4zNCAwIDE3VjIwSDE2VjE3QzE2IDE0LjM0IDEwLjY3IDEzIDggMTNaTTEyLjUxIDQuMDVDMTMuNDMgNS4xMSAxNCA2LjQ5IDE0IDhDMTQgOS41MSAxMy40MyAxMC44OSAxMi41MSAxMS45NUMxNC40NyAxMS43IDE2IDEwLjA0IDE2IDhDMTYgNS45NiAxNC40NyA0LjMgMTIuNTEgNC4wNVpNMTYuNTMgMTMuODNDMTcuNDIgMTQuNjYgMTggMTUuNyAxOCAxN1YyMEgyMFYxN0MyMCAxNS41NSAxOC40MSAxNC40OSAxNi41MyAxMy44M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GroupRemove = createIcon('GroupRemove', [
  [
    'path',
    {
      d: 'M24 9V11H18V9H24ZM8 4C5.79 4 4 5.79 4 8C4 10.21 5.79 12 8 12C10.21 12 12 10.21 12 8C12 5.79 10.21 4 8 4ZM8 13C5.33 13 0 14.34 0 17V20H16V17C16 14.34 10.67 13 8 13ZM12.51 4.05C13.43 5.11 14 6.49 14 8C14 9.51 13.43 10.89 12.51 11.95C14.47 11.7 16 10.04 16 8C16 5.96 14.47 4.3 12.51 4.05ZM16.53 13.83C17.42 14.66 18 15.7 18 17V20H20V17C20 15.55 18.41 14.49 16.53 13.83Z',
      key: '1sw4z9',
    },
  ],
]);

export default GroupRemove;
